import React from "react";
import classNames from "classnames";

const Section = ({ children, className, title }) => (
  <section className={classNames("section__wrapper", className)}>
    {title && title}
    {children}
  </section>
);

export default Section;
